import { Component } from '@angular/core';
import { AlertService } from '@lsq-frontend/angular-shared/features/alert-service';
import { environment } from '@lsq-frontend/fasttrack-shared/environment';
import { ResponseCode } from '@lsq-frontend/remote-services/enterprise/common';
import { Color, Modal } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { ModalService, ModalWorkflowService } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ManageUsersService } from '../../services/manage-users.service';

@Component({
    selector: 'add-user-permissions-modal',
    template: `
        <div class="modal-content">
            <div class="modal-header">
                <h1>{{ modal?.title }}</h1>
                <lsq-button
                    *ngIf="modal?.showCloseButton"
                    appearance="transparent"
                    class="close"
                    ariaLabel="Close"
                    (buttonClick)="modalService.closeModal()"
                >
                    <lsq-icon aria-hidden="true" [type]="icons.Close" [color]="color.Black">
                    </lsq-icon>
                </lsq-button>
            </div>
            <div class="modal-body">
                <p *ngIf="!isAdminCompany">{{ subtitle }}</p>
                <permissions
                    *ngIf="!isAdminCompany"
                    [readOnly]="false"
                    [modal]="true"
                    [newUser]="true"
                >
                </permissions>
                <admin-claims
                    *ngIf="isAdminCompany"
                    [readOnly]="false"
                    [newUser]="true"
                ></admin-claims>
            </div>
            <div class="modal-footer ok-btn-showing">
                <div class="modal-footer-left">
                    <lsq-button
                        appearance="transparent"
                        buttonClass="back-btn"
                        (buttonClick)="modalWorkflowService.previousStep()"
                        i18n="Go back button"
                    >
                        Go back
                    </lsq-button>
                </div>
                <div class="modal-footer-right">
                    <lsq-button
                        size="sm"
                        [submitting]="isSubmitting"
                        (buttonClick)="sendInvite()"
                        i18n="Call to action for an admin to invite a new user"
                    >
                        Send Invite
                    </lsq-button>
                </div>
            </div>
        </div>
    `
})
export class AddUserPermissionsModalComponent {
    private _duplicateUserMessage = this._i18n({
        value: 'This email has already been used to invite a user to your organization.'
    });
    private _failedToCreateUserMessage = this._i18n({
        value: 'Failed to create the user. Please refresh the page and try again.'
    });
    public subtitle = this._i18n({
        value:
            'The person you invite will receive an email with an invitation link that will expire in 12 hours. Once they click the link they can choose their password and register.'
    });
    public modal: Modal;
    public icons = Icons;
    public color = Color;
    public isSubmitting = false;

    constructor(
        public modalService: ModalService,
        public modalWorkflowService: ModalWorkflowService,
        private _manageUsersService: ManageUsersService,
        private _alertService: AlertService,
        private _i18n: I18n
    ) {}

    public ngOnInit(): void {
        this.modal = this.modalService.modal;
    }

    public async sendInvite(): Promise<void> {
        let error: any;

        this.isSubmitting = true;
        try {
            if (this.modal?.data?.isProspectInvite) {
                await this._manageUsersService.createUserForProspect();
            } else {
                await this._manageUsersService.createUserForClient();
            }
        } catch (_error) {
            error = _error;
            if (error?.code === ResponseCode.Conflict) {
                // Duplicate user.
                this._alertService.error(this._duplicateUserMessage);
            } else {
                this._alertService.error(this._failedToCreateUserMessage);
            }
        }
        this.isSubmitting = false;
        this.modalWorkflowService.hideWorkflow();

        if (error) {
            throw error;
        }
    }

    public get isAdminCompany(): boolean {
        return (
            (this._manageUsersService.addUserState.companyKey === environment.alanRuudCompanyKey ||
                this._manageUsersService.addUserState.companyKey ===
                    environment.lsqAdminCompanyKey) &&
            this._manageUsersService.isAdminClaims()
        );
    }
}
